const PENDING_TAG_REGEX = /<div\s[^>]*type="9am:[^"]*"[^>]*$/;

export function stripPendingTag(text: string): string {
  return text.replace(PENDING_TAG_REGEX, "");
}
